<template>
    <div class="components-container">
        <!-- 操作区域 -->
        <div class="filter-container">
            <el-button @click="addRec" type="success"><i class="el-icon-circle-plus-outline"></i>&nbsp;添加</el-button>
        </div>

        <!-- 列表区域 -->
        <el-table :data="tableData" v-loading.body="tableLoading"
            element-loading-text="信息加载中" stripe border fit highlight-current-row header-cell-class-name="tableHeadStyle"
            :height="mainTableHeight" ref="mainTable">
            <el-table-column label="学年" prop="oriCourseYear" align="center"></el-table-column>
            <el-table-column label="专业名称" prop="oriCourseMajor" align="center"></el-table-column>
            <el-table-column label="课程名称" prop="oriCourseName" align="center"></el-table-column>
            <el-table-column label="开课部门" prop="oriCourseDept" align="center"></el-table-column>
            <el-table-column label="学分" prop="oriCourseCredit" width="70px" align="center"></el-table-column>
            <el-table-column label="总学时" prop="oriCourseTotalTime" width="70px" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="180px">
                <template slot-scope="scope">
                    <el-button size="small" @click="modRec(scope.row);" type="warning">
                        <i class="el-icon-delete"></i>&nbsp;编辑
                    </el-button>
                    <el-button size="small" @click="delRec(scope.row);" type="danger">
                        <i class="el-icon-delete"></i>&nbsp;删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 表单区域 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" top="250px" append-to-body>
            <el-form ref="curdForm" :model="curdForm" label-width="100px" label-position="left" :rules="curdRules">
                <el-form-item label="人培学年" prop="oriCourseYear">
                    <el-select v-model="curdForm.oriCourseYear" filterable placeholder="请选择人培学年" style="width:100%;" @change="handleYearChange">
                        <el-option v-for="item in comboOption.year" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="人培专业" prop="oriCourseMajor">
                    <el-select v-model="curdForm.oriCourseMajor" filterable :placeholder="majorTips" style="width:100%;" :disabled="majorDisable" @change="handleMajorChange">
                        <el-option v-for="item in comboOption.major" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="人培课程" prop="oriCourseCode">
                    <el-select v-model="curdForm.oriCourseCode" filterable :placeholder="courseTips" style="width:100%;" :disabled="courseDisable">
                        <el-option v-for="item in comboOption.course" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="margin-top: 10px">
                <el-button type="primary" :loading="formSubmiting" @click="saveRec">保 存</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        props: ['teachingSchemeCode', 'courseCode'],
        data() {
            return {
                curYear: null,
                curMajorCode: null,
                //表数据
                tableData: [],
                //下拉选项数据
                comboOption: {
                    year: null,
                    major: null,
                    course: null,
                },
                majorTips: '请先选择人培学年',
                majorDisable: true,
                courseTips: '请先选择人培学年和人培专业',
                courseDisable: true,
                curdForm: {
                    id: null,
                    schemeCode: null,
                    courseCode: null,
                    oriSchemeCode: null,
                    oriCourseCode: null,
                    oriCourseYear: null,
                    oriCourseMajor: null,
                },
                tableLoading: true,
                mainTableHeight: 450,
                dialogTitle: null,
                dialogVisible: false,
                formSubmiting: false,
                curdRules: {
                    oriCourseYear: [{
                            required: true,
                            message: "请选择人培学年",
                            trigger: ["blur", "change"],
                        }
                    ],
                    oriCourseMajor: [{
                            required: true,
                            message: "请选择人培专业",
                            trigger: ["blur", "change"],
                        }
                    ],
                    oriCourseCode: [{
                            required: true,
                            message: "请选择人培课程",
                            trigger: ["blur", "change"],
                        }
                    ],
                },
            }
        },
        mounted() {
            this.curYear = this.teachingSchemeCode.substring(0, 4);
            this.curMajorCode = this.teachingSchemeCode.substring(4);

            this.initCombo();
            this.queryList();
        },
        methods: {
            queryList() {
                this.tableLoading = true;

                let params = {
                    schemeCode: this.teachingSchemeCode,
                    courseCode: this.courseCode,
                };
                this.$api.teachingManage.relatedCourse.list({
                    data: params,
                }).then((res) => {
                    this.tableData = res.data.data.list;
                    this.tableLoading = false;
                }).catch((err) => {
                    this.tableLoading = false;
                    console.log(err);
                });
            },
            initCombo() {
                let params = {
                    year: this.curYear,
                };
                this.$api.teachingManage.relatedCourse.initCombo({
                    data: params
                }).then((res) => {
                    this.comboOption.year = res.data.data.yearComboData;

                    if(this.comboOption.year.length > 0){
                        this.curdForm.oriCourseYear = this.comboOption.year[0].comboValue;
                        this.handleYearChange(this.curdForm.oriCourseYear);
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            handleYearChange(value){
                if(value == ''){
                    this.curdForm.oriCourseMajor = null;
                    this.majorTips = '请先选择人培学年';
                    this.majorDisable = true;
                }else{
                    this.loadMajorCombo();
                    this.majorTips = '请选择人培专业';
                    this.majorDisable = false;
                }

                this.curdForm.oriCourseCode = null;
                this.courseTips = '请先选择人培学年和人培专业';
                this.courseDisable = true;
            },
            loadMajorCombo() {
                let params = {
                    year: this.curdForm.oriCourseYear,
                };
                this.$api.teachingManage.relatedCourse.majorCombo({
                    data: params,
                }).then((res) => {
                    this.comboOption.major = res.data.data.majorComboData;

                    //默认选中当前专业
                    for(let i=0; i<this.comboOption.major.length; i++){
                        if(this.comboOption.major[i].comboValue === this.curMajorCode){
                            this.curdForm.oriCourseMajor = this.comboOption.major[i].comboValue;
                            this.handleMajorChange(this.curdForm.oriCourseMajor);
                            break;
                        }
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            handleMajorChange(value){
                if(value == ''){
                    this.curdForm.oriCourseCode = null;
                    this.courseTips = '请先选择人培学年和人培专业';
                    this.courseDisable = true;
                }else{
                    this.loadCourseCombo();
                    this.courseTips = '请选择人培课程';
                    this.courseDisable = false;
                }
            },
            loadCourseCombo() {
                let params = {
                    id: this.curdForm.id,
                    year: this.curYear,
                    courseCode: this.curCourseCode,
                    oriSchemeCode: this.curdForm.oriCourseYear + this.curdForm.oriCourseMajor,
                };
                this.$api.teachingManage.relatedCourse.courseCombo({
                    data: params,
                }).then((res) => {
                    this.comboOption.course = res.data.data.courseComboData;
                }).catch((err) => {
                    console.log(err);
                });
            },
            addRec(){
                this.dialogTitle = '添加';
                this.dialogVisible = true;
                this.curdForm.oriCourseYear = null;
                this.curdForm.oriCourseMajor = null;
                this.curdForm.oriCourseCode = null;

                if(this.comboOption.year.length > 0){
                    this.curdForm.oriCourseYear = this.comboOption.year[0].comboValue;
                    this.handleYearChange(this.curdForm.oriCourseYear);
                }
                this.$nextTick().then(() => {
                    if(this.$refs['curdForm'] !== undefined){
                        this.$refs['curdForm'].clearValidate();
                    }
                });
            },
            modRec(rowData){
                this.dialogTitle = '编辑';
                this.dialogVisible = true;

                this.$nextTick().then(() => {
                    this.curdForm.id = rowData.id;
                    this.curdForm.oriCourseYear = rowData.oriCourseYear;
                    this.curdForm.oriCourseMajor = rowData.oriSchemeCode.substring(4);
                    this.handleMajorChange(this.curdForm.oriCourseMajor);
                    this.curdForm.oriCourseCode = rowData.oriCourseCode;
                });
            },
            saveRec() {
                this.formSubmiting = true;

                this.$refs['curdForm'].validate((valid) => {
                    if (valid) {
                        this.curdForm.schemeCode = this.teachingSchemeCode;
                        this.curdForm.courseCode = this.courseCode;
                        this.curdForm.oriSchemeCode = this.curdForm.oriCourseYear + this.curdForm.oriCourseMajor;

                        this.$api.teachingManage.relatedCourse.save({
                            data: this.curdForm,
                        }).then((res) => {
                            this.formSubmiting = false;
                            switch (res.data.data.state) {
                                case 'Success':
                                    this.dialogVisible = false;
                                    showNotify('成功', "保存成功", 'success', 1500);
                                    this.queryList();
                                    break;
                                default:
                                    showNotify('错误', "保存失败", 'error', 3000);
                                    break;
                            }
                        }).catch((err) => {
                            this.formSubmiting = false;
                            showNotify('错误', err, 'error', 3000);
                        });
                    } else {
                        this.formSubmiting = false;
                        return false;
                    }
                });
            },
            delRec(rowData){
                confirmMsg('是否确定要删除选择的关联课程信息？').then(() => {
                    this.curdForm.id = rowData.id;

                    this.$api.teachingManage.relatedCourse.del({
                        data: this.curdForm,
                    }).then((response) => {
                        let state = response.data.data.state;

                        if (state == 'Success') {
                            showNotify('成功', "删除成功", 'success', 1500);

                            this.queryList();
                        }else{
                            showNotify('失败', "删除失败", 'error', 3000);
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
        }
    };
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// relatedCourseConfig.vue?9516d266